const SET_ADMIN = 'SET_ADMIN';

const initialState = {
  admin: false,
};

export function adminReducer(state = initialState, action = {}) {
  const { type, _data } = action;

  switch (type) {
    case SET_ADMIN:
      return {
        admin: true,
      };

    default:
      return state;
  }
}

// Action creators
export const setAdmin = () => ({ type: SET_ADMIN });
